import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom'
import {Box, Button, Flex, Heading, Text} from 'rebass'
import {Block, Tabs} from 'reakit'
import {
	ActiveTabCircle,
	InactiveTabCircle,
	Sidebar,
	SubcategoryCard,
	SubHeading,
	TabWrapper,
	TitleSection,
	Wrapper,
	VerticalScroll
} from './styles'
import PopupForm from '../../components/Modals/PopupForm'
import {NewCalendarCategory, NewCalendarSchedule} from "../../components/Forms";

import {FlexLoading} from "../../components/Base/Loading";
import moment from "moment";

const ManageCalendar = props => {
	const {categories, updateStaged, handleSubmitStaged, currentDate} = props;

	// const [currentCategories, updateStaged] = useState(categories)
	const [hasChanges, updateHasChanges] = useState(false)

	const submitStagedChanges = () => {
		handleSubmitStaged(categories)
		updateHasChanges(false)
	}

	// creates a temp ID and adds a new category to staged changes
	const handleNewStagedCategory = (values) => {
		const timestamp = Math.floor(Date.now() / 1000)

		console.log(values)
		const newCategory = {
			id: `new-${timestamp}`,
			...values,
			schedule: [],
			activated: {
				id: currentDate,
				date: currentDate,
				schedule: [],
				last_updated: `new-${timestamp}`
			}
		}

		const newCategories = [
			...categories,
			newCategory
		]
		updateStaged(newCategories)
		updateHasChanges(true)
	}

	// Updates staged changes to a category's subcategory/schedule
	const handleStagedSchedule = (values) => {
		console.log(values)
		const categoryID = values.category
		delete values.category
		let updatedCategory = categories.filter(item => item.id === categoryID)[0]
		console.log(updatedCategory)
		const timestamp = Math.floor(Date.now() / 1000)
		let updatedSchedule = updatedCategory.schedule


		if(values.id){
			console.log('updated schdule', updatedSchedule)
			for(let i in updatedSchedule ){
				if(updatedSchedule[i].id === values.id){
					let currentScheduleItem = updatedSchedule[i]
					currentScheduleItem = {
						...currentScheduleItem,
						...values,
						// stagedChanges is deleted by the container before saving to firestore
						stagedChanges: true
					}
					updatedSchedule[i] = currentScheduleItem
				}
				console.log('updated schdule result', updatedSchedule)

			}
			// if activated, make sure the category schedule array has the subcategory id
			if(values.activated === true && !updatedCategory.activated.schedule.includes(values.id)){
				console.log('activated')

				updatedCategory.activated.schedule.push(values.id)
			}
			// if not activated, make sure the category schedule array does not include the subcategory id
			if(values.activated === false && updatedCategory.activated.schedule.includes(values.id)){
					console.log('deactivated')
				for(let i = updatedCategory.activated.schedule.length -1; i >= 0; i--){
					if(updatedCategory.activated.schedule[i] === values.id){
						updatedCategory.activated.schedule.splice(i, 1);
					}
				}
			}
		} else {
			if(values.id && values.id.split('-')[0] === 'new'){

			} else{
				let newScheduleItem = {
					id: `new-${timestamp}`,
					...values
				}
				updatedSchedule.push(newScheduleItem)
			}

		}



		let updatedCategories = categories.map(item => item.id === categoryID ? {...updatedCategory, schedule: updatedSchedule} : item )

		console.log('updated categories', updatedCategories)
		updateStaged(updatedCategories)
		updateHasChanges(true)

	}

	const hasCategory = categories && categories.length > 0

	const dateString = moment(currentDate).format("dddd, MMM Do");

	return (
		<Wrapper>
			<TitleSection>
				<Flex justifyContent={'space-between'} flexWrap={'wrap'} flexDirection={'row'}>
					<Box>
						<Heading>Today On The Hill</Heading>
						<SubHeading m={0} lineHeight={1}>{dateString}</SubHeading>

					</Box>
					<Flex flexDirection={'column'} flexWrap={'wrap'} justifyContent={'center'}>
						<Box>
							<Button variant={'main'} bg={hasChanges ? 'blue' : 'meta'} disabled={!hasChanges} m={1} onClick={submitStagedChanges}>Save</Button>
							<Link to={'/app/calendar'}><Button variant={'main'} bg={'gray'} m={1}>Discard</Button></Link>
						</Box>
					</Flex>
				</Flex>
			</TitleSection>

			<Tabs.Container>
				{(tabs) =>
					(
					<Block>
						<Tabs boxShadow={'none'}>
							<Flex flexDirection={'row'} flexWrap={'wrap'} css={{height: '100%'}}>


								<Sidebar>
									<Flex flexDirection={'column'} flexWrap={'wrap'} alignItems={'center'}>
										<Box mx={2} my={3}>
											<PopupForm
												FormComponent={NewCalendarCategory}
												handleSubmit={handleNewStagedCategory}/>
										</Box>


										{categories.map((item, x)=> (
											<Tabs.Tab key={item.id} tab={item.id} {...tabs} width={'100%'}>
											<Flex width={1} pl={'10px'} my={3}>
												<Flex flexWrap={'wrap'} flexDirection={'column'} justifyContent={'center'} px={3}>
													{tabs.current === x ? <ActiveTabCircle/> : <InactiveTabCircle/>}
												</Flex>
												<Box pr={3}>
													<Heading lineHeight={0.8} as={'h3'}>{item.name}</Heading>
													{categories[x].activated.date === currentDate ?
														<Text
															color={'meta'}>Active:

															{item.schedule && item.schedule.filter(item => item.activated).length > 0
																	? item.schedule.filter(item => item.activated).map(item => item.name).join(', ')
																	: "None"
																}
														</Text>
														: <Text
															color={'meta'}>Active: Loading.. </Text>
													}
												</Box>
											</Flex>
											</Tabs.Tab>
										))}


									</Flex>
								</Sidebar>


								<TabWrapper>
									{hasCategory &&
									<Box width={1} p={3}>
										<PopupForm
											FormComponent={NewCalendarSchedule}
											handleSubmit={(values) => handleStagedSchedule({...values, category: tabs.ids[tabs.current]})}
										/>
									</Box>}

									{categories && categories.filter(item => item.id === tabs.ids[tabs.current]).map(item => (
										<Box>
											<Flex flexDirection={'column'} flexWrap={'wrap'}>
												<Box width={1} p={2} pb={3} pl={3}>
													<Heading as={'h3'}>Active Schedule ({item.schedule.filter(item => item.activated).length})</Heading>
														{item.activated.date === currentDate ?
																<VerticalScroll py={1}>
																	{item.schedule.filter(item => item.activated).map((item, key) => {
																		return (
																		<Box
																			key={key}
																			width={[1, 1, 1 /2 , 1 / 3]}	
																			p={'10px'}
																		>
																			<PopupForm
																				key={item.id}
																				FormComponent={NewCalendarSchedule}
																				handleSubmit={(values) => handleStagedSchedule({
																					...values,
																					category: tabs.ids[tabs.current]
																				})}
																				initialValues={item}
																				ShowComponent={(props) => (
																					<SubcategoryCard {...props}>
																						<Heading as={'h5'} lineHeight={1}>{item.name}</Heading>
																						<Text color={'meta'}>Click to configure</Text>
																					</SubcategoryCard>
																				)}
																			/>
																		</Box>
																	)})}
																</VerticalScroll>
																:
																<FlexLoading justifyContent={'center'}/>
														}
												</Box>

												<Box width={1} p={2} pl={3} pt={3}>
													<Heading as={'h3'}>Inactive Schedule ({item.schedule.filter(item => !item.activated).length})</Heading>

													<VerticalScroll py={1}>
															{item.schedule.filter(item => !item.activated).map((item, key) => {
																return (
																<Box
																	key={key}
																	width={[1, 1, 1 /2 , 1 / 3]}	
																	p={'10px'}
																>
																	<PopupForm
																		key={item.id}
																		FormComponent={NewCalendarSchedule}
																		handleSubmit={(values) => handleStagedSchedule({...values, category: tabs.ids[tabs.current]})}
																		initialValues={item}
																		ShowComponent={(props) => (
																			<SubcategoryCard {...props}>
																				<Heading as={'h5'} lineHeight={1} color={'meta'}>{item.name}</Heading>
																				<Text color={'meta'}>Click to configure</Text>
																			</SubcategoryCard>
																		)}
																	/>
																</Box>
																)
															})}
													</VerticalScroll>
												</Box>
											</Flex>
										</Box>
									))}

								</TabWrapper>
							</Flex>

						</Tabs>
					</Block>
				)}
			</Tabs.Container>
		</Wrapper>
	);
};

ManageCalendar.propTypes = {
	categories: PropTypes.array,
	handleSubmitCategory: PropTypes.func,
	handleSubmitSchedule: PropTypes.func,
	handleUpdateSchedule: PropTypes.func,
	handleSubmitStaged: PropTypes.func,
	currentDate: PropTypes.string
};

ManageCalendar.defaultProps = {
	categories: [],
	handleSubmitCategory: (values) => console.log('new category', values),
	handleSubmitSchedule: (values) => console.log('new schedule', values),
	handleUpdateSchedule: (values) => console.log('update schedule', values),

};
export default ManageCalendar;
